// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__j-4V6","content":"style_content__4Cxk5"};